import React, { useMemo, useCallback, useState } from "react";
import { useApolloClient } from "@apollo/client";
import { AgGrid, AgGridReact, Grid } from "@jsq/ds/core";
import { PayeeDetails } from "../PayeeDetails";
import { columnDefinitions } from "./columnDefinitions";
import { PayeesGraphqlDataSource } from "./payeesGQLDataSource";
import { tableContainer } from "./styles_vanilla.css";
import { PayeeRowItem } from "./types";

const rowCountPerPage = 20;

const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  enableCellTextSelection: true,
  pagination: true,
  paginationPageSize: rowCountPerPage,
  paginationPageSizeSelector: false,
  suppressCellFocus: true,
  suppressContextMenu: true,
};

const defaultColumnOptions = {
  editable: false,
  flex: 1,
  minWidth: 100,
  sortable: false,
};

export const PayeesTable: React.FC = () => {
  const client = useApolloClient();
  const [isPayeeDetailsOpen, setIsPayeeDetailsOpen] = useState(false);
  const [selectedPayeeId, setSelectedPayeeId] = useState<string | null>(null);

  const gridDataSource = useMemo<AgGrid.IServerSideDatasource>(() => {
    return new PayeesGraphqlDataSource(client, rowCountPerPage);
  }, [client]);

  const onRowClicked = useCallback((event: AgGrid.RowClickedEvent<PayeeRowItem>) => {
    const payeeRowDetails = event.data;
    if (payeeRowDetails) {
      setSelectedPayeeId(payeeRowDetails.id);
      setIsPayeeDetailsOpen(true);
    }
  }, []);

  const handleClosePayeeDetails = useCallback(() => {
    setIsPayeeDetailsOpen(false);
    setSelectedPayeeId(null);
  }, []);

  return (
    <>
      <Grid<PayeeRowItem>
        className={tableContainer}
        cacheBlockSize={rowCountPerPage}
        columnDefs={columnDefinitions}
        defaultColDef={defaultColumnOptions}
        gridId="payees_table"
        gridOptions={{
          ...gridOptions,
        }}
        onRowClicked={onRowClicked}
        reactiveCustomComponents
        rowModelType="serverSide"
        serverSideDatasource={gridDataSource}
      />
      <PayeeDetails
        isOpen={isPayeeDetailsOpen}
        onClose={handleClosePayeeDetails}
        payeeId={selectedPayeeId}
      />
    </>
  );
};

export default PayeesTable;
